'use strict';

angular.module('userRequestEditControllers')

.directive('sameAs', [function () {
    return {
        scope: {
            sameAsEmployee: '=',
            accessRequest: '=',
            nextStepWhenGettingStarted: '&'
        },
        restrict: 'A',
        templateUrl: require('./SameAs.tpl.html'),
        controller: ['$scope', '$modal', '$state', 'editAccessRequestService', function ($scope, $modal, $state, editAccessRequestService) {

            $scope.selectEmployeeSameAs = function () {

                var modalScope = $scope.$new(true);
                modalScope.userRequest = $scope.accessRequest;

                var sameAsModal = $modal({
                    scope: modalScope,
                    template: require('./selectEmployeeSameAsModal.tpl.html'),
                    placement: 'center'
                });

                modalScope.hideModal = function () {
                    sameAsModal.$promise.then(sameAsModal.hide);
                }

                modalScope.cancelModal = function () {
                    modalScope.hideModal();
                }

                // When select employee to compare
                modalScope.compareEmployee = function (employee) {
                    modalScope.hideModal();

                    $scope.sameAsEmployee = employee;

                    if ($state.is('userAccessRequest.edit')) {
                        $scope.nextStepWhenGettingStarted({ params: { sameAsEmployee: employee }});
                    }
                    else {
                        $state.go($state.current, { sameAsEmployeeId: employee.EmployeeID },
                                  { reload: true });
                    }
                }

                // When copy all permissions from an employee
                modalScope.copyAllPermissions = function (employee) {
                    modalScope.hideModal();

                    var requestId = $scope.accessRequest.UserAccessRequestID;
                    var sameAsEmployeeId = employee.EmployeeID;

                    editAccessRequestService.sameAs.copyAllSystemRoles(requestId, sameAsEmployeeId)
                    .then(function () {
                        $state.go('userAccessRequest.edit.validationMessages', {
                            userAccessRequestId: requestId,
                            sameAsEmployeeId: sameAsEmployeeId
                        },
                        { reload: true });
                    });
                }
            }
        }],
        link: function (scope, element, attrs) {
        }
    };
}]);
